import React, {Component} from "react";
import {Button, Header, Modal, Table} from "semantic-ui-react";
import moment from "moment";
import CreateNotesForm from './CreateNotesForm'


export default class ViewNotes extends Component {
    state = { editNote: false, createNote: false}
    openCreateNoteModal = () => {
        this.setState({createNote: true})
    }
    closeCreateNoteModal = () => {
        this.setState({createNote: false})
    }
    EditCreateNoteFormModal = (props) => {
        return (
            <Modal
                closeIcon
                open={true}
                onClose={props.closeForm}
            >
                <Header content={props.content}/>
                <Modal.Content>
                    <CreateNotesForm
                        action={props.action}
                        submitForm={props.submitForm}
                        closeForm={props.closeForm}
                        item={props.item}
                    />
                </Modal.Content>
            </Modal>
        )
    }

    render(){
        const { hideModal, notes, issue, submitForm } = this.props;
        const { editNote, createNote} = this.state;
        return (
            <Modal
                closeIcon
                open={true}
                centered={true}
                onClose={hideModal}
            >
                <Modal.Header>
                    <h2 className="text-center"><span className="text-uppercase"></span>Notes</h2>
                    <Button className="float-right"
                            primary={true} onClick={this.openCreateNoteModal}>New Note</Button>
                </Modal.Header>
                <Modal.Content>
                    <div className="ui card">
                        <div className="content pb0 mb10" style={{maxHeight: "65vh", overflowY: "auto"}}>
                            <Table basic={true}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell content="Description"/>
                                        <Table.HeaderCell content="User"/>
                                        <Table.HeaderCell content="TimeStamp"/>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {
                                        notes && notes.length ? notes.map((log, key) =>
                                            <Table.Row key={'log_' + key}>
                                                <Table.Cell content={log.description}/>
                                                <Table.Cell content={log.user}/>
                                                <Table.Cell content={moment(log.createdAt).format('DD MMM YYYY :HH:mm')}/>
                                            </Table.Row>
                                        ) :  <Table.Row key='0'>
                                            <Table.Cell colSpan={3} className="text-center" content='No Data Found'/>
                                        </Table.Row>
                                    }
                                </Table.Body>
                            </Table>
                        </div>
                    </div>

                    {
                        editNote && this.EditCreateNoteFormModal({
                            content: "Edit Note",
                            action: "editForm",
                            submitForm : {submitForm},
                            closeForm: this.closeCreateNoteModal,
                            item: issue
                        })
                    }
                    {
                        createNote && this.EditCreateNoteFormModal({
                            content: "Create Note",
                            action: "createForm",
                            submitForm : {submitForm},
                            closeForm: this.closeCreateNoteModal,
                            item: issue
                        })
                    }
                </Modal.Content>
            </Modal>
        );
    }
}